import { UnifiedReports as UnifiedReportsView } from '@layerfi/components'
import { useOutletContext } from 'react-router-dom'

import {
  isBasisToggleEnabled,
  ReportingBasisToggleInjector,
} from '../../../components/ReportingBasisToggle'
import { AccountingLayout } from '../../../layouts/AccountingLayout'

export const UnifiedReports = () => {
  const { demoName } = useOutletContext<{ demoName?: string }>()

  return (
    <AccountingLayout>
      <UnifiedReportsView />
      {isBasisToggleEnabled(demoName) && <ReportingBasisToggleInjector />}
    </AccountingLayout>
  )
}
